import { render, staticRenderFns } from "./DDJ.vue?vue&type=template&id=4f4ae8fb&scoped=true&"
import script from "./DDJ.vue?vue&type=script&lang=js&"
export * from "./DDJ.vue?vue&type=script&lang=js&"
import style0 from "./DDJ.vue?vue&type=style&index=0&id=4f4ae8fb&lang=scss&scoped=true&"
import style1 from "./DDJ.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ae8fb",
  null
  
)

export default component.exports